<template>
  <div class="px-4">
    <section class="flex items-center flex-col lg:flex-row max-w-6.5xl mx-auto px-2 py-18">
      <div class="grow-[4] shrink-[3] basis-0 lg:mr-[80px] w-full">
        <img :src="imagePath" class="w-full h-full object-cover rounded-[10px]" alt="global team" />
      </div>

      <div class="grow-[3] shrink-[4] basis-0 mt-7.5">
        <h2 class="h2 font-alt text-gray-900 !tracking-normal">
          {{ title }}
        </h2>
        <p class="whitespace-pre-line mt-4.5 text-gray-600 font-normal !leading-[24px]">
          {{ description }}
        </p>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { getImageUrl } from "~/utils";

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  imageName: {
    type: String,
    default: '',
  }
});

const imagePath = computed<string>(() => getImageUrl(props.imageName));
</script>
